// Shared link configuration for desktop and mobile navigation.
export const serviceLinks = [
  { name: "Website Building", path: "/website-design-uk" },
  { name: "AI Agents & Automation", path: "/ai-automation-agents-uk" },
];

export const primaryLinks = [
  { name: "Home", path: "/", testId: "nav-link-home" },
  { name: "About", path: "/about", testId: "nav-link-about" },
  { name: "Pricing", path: "/pricing", testId: "nav-link-pricing" },
  { name: "Contact", path: "/contact", testId: "nav-link-contact" },
];
